import React, { useState, useRef, useEffect } from 'react'
import { camelizeKeys } from 'humps'
import { formatPhoneNumber, formatPhoneNumberIntl } from 'react-phone-number-input'

const PlayerHeader = ({ query, setQuery, selectedPlayer, onPickPlayer, onPickPlayers, onShowPlayer }) => {
  const [matchingPlayers, setMatchingPlayers] = useState([])
  const timer = useRef()

  useEffect(() => {
    setMatchingPlayers([])

    return () => clearTimeout(timer.current)
  }, [selectedPlayer])

  const onChangeQuery = (value) => {
    setQuery(value)

    clearTimeout(timer.current)
    timer.current = setTimeout(()=> onSearch(value), 500)
  }

  const onSearch = async (value) => {
    if (value.length < 3 || value.includes(',')) return setMatchingPlayers([])

    const response = await fetch(`/admins/chatmates?query=${value}`)
    const json = await response.json()

    if (!value.includes(',')) setMatchingPlayers(json.players)
  }

  const pickPlayers = e => {
    if (!e.currentTarget.value.includes(',')) return

    setMatchingPlayers([])
    fetch(`/admins/chatmates?query=${e.currentTarget.value}`)
      .then(response => response.json())
      .then(json => json.players.length && onPickPlayers(json.players))
  }

  const pickPlayer = player => {
    setQuery('')
    onPickPlayer(camelizeKeys(player))
    setMatchingPlayers([])
  }

  const formattedPhone = () => {
    if (!selectedPlayer) return
    if (selectedPlayer.countryCode && selectedPlayer.countryCode.toLowerCase() != 'us') return formatPhoneNumberIntl(selectedPlayer.phone)
    return formatPhoneNumber(selectedPlayer.phone)
  }

  return [
    <div className='chat-header-content' key='content'>
      <div className='search'>
        <input
          placeholder='Search for player...'
          value={query}
          onChange={e => onChangeQuery(e.currentTarget.value)}
          onBlur={pickPlayers}
        />
      </div>
      <div className='selected-wrapper'>
        { selectedPlayer &&
          <div className='selected-player'>
            { selectedPlayer.id && !selectedPlayer.hasApp && <div className='no-app'>No App</div> }
            <div className='info'>
              <div className='name'>{selectedPlayer.name}</div>
              { selectedPlayer.phone &&
                <div className='phone-container' onClick={() => navigator.clipboard.writeText(formattedPhone())}>
                  <img src='/images/copy-icon.png' title='Copy Phone'/>
                  <div className='phone'>{formattedPhone()}</div>
                </div>
              }
            </div>
            <div className='avatar' onClick={() => onShowPlayer(selectedPlayer.id)}>
              <img src={selectedPlayer.avatar || '/images/ic_user@2x.png'} />
            </div>
          </div>
        }
      </div>
    </div>,
    <div className='matching-wrapper' key='wrapper'>
      { matchingPlayers.length > 0 &&
        <div className='matching-players'>
          { matchingPlayers.map(p =>
            <div key={p.id} className='player' onClick={e => pickPlayer(p)}>{p.name} - {p.phone}</div>
          )}
        </div>
      }
    </div>
  ]
}

export default PlayerHeader
